import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { t } from 'services/translation';
import {
  signUpRequest,
  resetSubmitSucceeded,
} from 'data_system/token_auth/actions';
import {
  getBrand,
  getSubmitting,
  getSubmitSucceeded,
  getAuthError,
} from 'data_system/token_auth/selectors';
import { titleize } from 'lib/string_utils';
import { LOGIN } from './routes';
import { Button } from './elements/Button';
import { ButtonLink } from './elements/ButtonLink';
import { FormFooter } from './FormFooter';
import FormSubfooter from './FormSubfooter';
import {
  Label,
  Input,
  Heading,
  Subheading,
  Form,
  FormContainer,
  Error,
  InputSection,
} from './styles_auth';

const SignUpRequestPage = () => {
  const dispatch = useDispatch();
  const { name } = useSelector(getBrand);
  const submitting = useSelector(getSubmitting);
  const submitSucceeded = useSelector(getSubmitSucceeded);
  const error = useSelector(getAuthError);

  const [email, setEmail] = useState(localStorage.getItem('email') || '');

  useEffect(() => {
    document.title = `${name} - ${t('REQUEST_INVITATION')}`;
  }, []);

  // Cleanup submitSucceeded on unmount
  useEffect(() => {
    return () => dispatch(resetSubmitSucceeded);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(signUpRequest({ email }));
  };

  const emailInputStep = (
    <React.Fragment>
      <Heading bold>{t('REQUEST_INVITATION_EMAIL')}</Heading>
      <Subheading>
        {t(`Please enter the email address that you have used with ${name} to request an invitation
        email.`)}
      </Subheading>
      <Form onSubmit={handleSubmit}>
        <Label>{titleize(t('EMAIL_ADDRESS'))}</Label>
        <InputSection>
          <Input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputSection>
        {error ? <Error>{error}</Error> : null}
        <Button disabled={submitting} text={t('SUBMIT')} />
      </Form>
      <FormSubfooter />
      <FormFooter />
    </React.Fragment>
  );

  const submitSuccessStep = (
    <React.Fragment>
      <Heading bold>{t('INVITATION_EMAIL_SENT')}</Heading>
      <Subheading>
        {t('WE_JUST_SENT_AN_EMAIL_TO')} <strong>{email}</strong>.{' '}
        {t(
          'PLEASE_CHECK_YOUR_EMAIL_AND_FOLLOW_THE_LINK_TO_COMPLETE_YOUR_REGISTRATION'
        )}
      </Subheading>
      <ButtonLink text={t('RETURN_TO_LOGIN')} to={LOGIN} />

      <FormFooter />
    </React.Fragment>
  );

  return (
    <FormContainer>
      {submitSucceeded ? submitSuccessStep : emailInputStep}
    </FormContainer>
  );
};

export default SignUpRequestPage;
